<template lang="pug">
  article.banner.loading.row.middle.center(v-if='loading')
    loader(size="inner")
  article.banner.relative.row.middle.center(v-else :style='bannerStyle')
    .shadow.absolute
    .text.column.middle.center
      h4.title-medium.white.bold {{ subtopicInfo.name }}
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Loader from '../../Loader'

export default {
  components: { Loader },
  data() {
    return {
      loading: true
    }
  },
  async created() {
    this.loading = true
    await this.hydrateSubtopicData(Number(this.$route.query.subtopicIds))
    this.loading = false
  },
  computed: {
    ...mapState({
      subtopicInfo: state => state.newFeed.searchResults.subtopic.data
    }),
    bannerStyle() {
      return {
        'background-image': `url("${this.subtopicInfo.imageURL}")`,
        'background-size': 'cover',
        'background-position': 'center'
      }
    }
  },
  methods: {
    ...mapActions([
      'hydrateSubtopicData'
    ])
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';

.banner{
  border-radius: 8px;
  height: 200px;
  width: 100%;
  overflow: hidden;
  &.loading{
    background-color: $light-gray;
  }
  .text{
    z-index: 1;
  }
  .shadow{
    height: 100%;
    width: 100%;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.4) 46.94%);
  }
}
</style>
